import TagManager from "react-gtm-module"

export default function initGTMService() {
    TagManager.initialize({ gtmId: "GTM-THXRXB5" })
}
